<template>
 <div> {{ActDescBtn}}
 <table style="position: absolute;" width="100%"  :height="this.windowSize.height-8"  :max-height="this.windowSize.height-8" >
   <tr max-height="48px" height="48px">   

<ContenidoBase 
  :titulo="'Utilitario Gastos Menores'"
  :descripcion="'Utilitario Gastos Menores'"
   :EstadoBtn="EstadoBtn"
   @abrirBarraTablaDinamica="abrirTabla"
   @MethodNuevo="newwnuevo"
   @MethodGuardar="save"
   @MethodEliminar="remove"
   @MethodAnular="anular"
   @MethodImprimir="imprimirList"  
/>
    </tr>
    <tr>
<!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">

         <div class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">
        
        <v-tooltip left>
          <template v-slot:activator="{ on }">
              <center>
              <v-btn-toggle>
                <v-btn
                  small
                  color="yellow accent-4"
                  @click.prevent="actualiza_tb_ver"
                >
                  <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn
                >
                <v-btn
                  small
                  dark
                  color="deep-purple accent-2"
                  @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn
                >
              </v-btn-toggle>
            </center>
            <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitBancos'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
          </template>
        </v-tooltip>

      </div>
      </td>
<!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
<!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height-96" >
        <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
 

 <div class="px-2" >
  <v-card color="grey lighten-3">
    <div class="px-2" >
  <v-form ref="formGastoMenores" @submit.prevent=""  v-model="valid" lazy-validation>
              <v-row>

<!-- columna 1 -->
<v-col cols="12" md="6" sm="6" >

  <!-- -----------------------------  fechaInicial  -->
<v-text-field
        class="fontSize12 pb-2"
        dense
        outlined
        type="date"  
        label="Fecha Desde"
         :rules="[$rules.required]"
        v-model="busquedaGastosMenores.fechaInicial"
        hide-details
        @blur="BlurDesde"
        @input="getGastosMenores"
        v-on:input="resertPaginacion"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>

</v-text-field>

 <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <!-- Factura No --------------------------------------------------->
                          <v-text-field
                            hide-details
                            class="fontSize12 pb-2"
                            v-on="on"
                            label="No.Gas:"
                            autocomplete="off"
                            dense
                            outlined
                            v-model.number="busquedaGastosMenores.Nogasto"
                            @keyup="KeyUpCantidad"
                            placeholder=" "
                            style="font-size: 12px"
                            @input="getGastosMenores"
                            v-on:input="resertPaginacion"
                          >
                            <template v-slot:prepend>
                              <i style="font-size: 18px" class="fa fa-slack"></i>
                            </template>
                          </v-text-field>
                        </template>
                        <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                          <span>Se registra el número de factura de venta que se desea buscar.</span>
                        </i>
 </v-tooltip>

</v-col>
<!-- fn columna 1 -->
<!-- columna 2 -->
<v-col cols="12" md="6" sm="6">
  <!-- -----------------------------  fechaInicial  -->
<v-text-field
        class="fontSize12 pb-2"
        dense
        outlined
        type="date"  
        label="Fecha Hasta"
         :rules="[$rules.required]"
        v-model="busquedaGastosMenores.fechaFinal"
        hide-details
        @blur="BlurHasta"
         @input="getGastosMenores"
        v-on:input="resertPaginacion"
        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>

</v-text-field>

<v-text-field   v-if="false"
                        label="NCF"
                        autocomplete="off"
                        dense
                        outlined
                        v-model="busquedaGastosMenores.ncf"
                        @blur="getGastosMenores"
                        v-on:blur="resertPaginacion"
                        hide-details
                            class="fontSize12"
                      >
                        <template v-slot:prepend>
                          <i style="font-size: 20px" class="fa fa-barcode"></i>
                        </template>
                      </v-text-field>

  <v-col v-if="false" cols="12" md="12" sm="12" class="pt-0 mt-0">
    <center>
<!-- class="pa-0 ma-0 py-0 my-0" :class="`d-flex justify-center white--text`"-->
  <!-- <v-row no-gutters></v-row> -->
  <span style="font-size: 12px"><b>OPCION FAC. ELECTRÓNICO:</b><!-- <span style="color: #C62828;"> Para </span> --> </span>
<v-radio-group dense @change="getGastosMenores"  hide-details class="pt-0 mt-0 d-flex justify-center "  v-model="busquedaGastosMenores.opcion" row>     
                  <!-- <v-radio label="RUTINARIOS" color="green" :value="1"></v-radio>
                  <v-radio label="NO RUTINARIOS" color="green" :value="2"></v-radio>-->
                  <v-radio  label="" color="green" :value="0">
                    <template v-slot:label>
                      <strong style="color: #000000; font-size: 11px">TODOS</strong>
                    </template>
                  </v-radio>
                  <v-radio  label="" color="green" :value="1">
                    <template v-slot:label>
                      <strong style="color: #000000; font-size: 11px">NO ENVIADA</strong>
                    </template>
                  </v-radio>

                  <v-radio  label="" color="green" :value="2">
                    <template v-slot:label>
                      <strong style="color: #000000; font-size: 11px">ENVIADA</strong>
                    </template>
                  </v-radio>
                                                          
                  
</v-radio-group>
<v-text-field class="pt-0 mt-0 fontSize12" hide-details v-if="busquedaGastosMenores.opcion==2"  autocomplete="off"  v-model="busquedaGastosMenores.buscarTrackId" 
               label="" dense single-line  style="border:1px solid #000000;"
               @blur="getGastosMenores">
              <template v-slot:prepend-inner>
                <i style="font-size: 20px;" class="fa fa-search"></i>
              </template>
              <template v-slot:label>
                <!-- <strong style="color: #000000; font-size: 11px">BUSCAR CON REF:(Aceptado/Rechazado)</strong> -->
                <span style="font-size: 11px" >BUSCAR CON REF:(Aceptado/Rechazado)</span>
              </template>
            </v-text-field>
</center>

 </v-col>

</v-col>
<!-- fn columna 2 -->

 </v-row>
</v-form>
<v-col cols="12" md="12" sm="12">
 <div style="border: 1px solid #000000;" >
<v-data-table
      class="RowSelectColor elevation-1 RowSelectColor TbSize12"
      :single-select="true"
      :show-select="true"
       item-key="indx"
       v-model="selected"
       @item-selected="obtenerDatoSelect"
       :footer-props="$arrayPropiedasesGlobal"
      :headers="[
                 { text: 'FECHA', sortable: false, value: 'nuevaFecha', width:120, class: ['no-gutters black--text']  },
                 { text: '# GAS', sortable: false, value: 'gastosmenoresPK.secuencia', width:129, class: ['no-gutters black--text']  },
                 { text: 'DOCUMENTO', sortable: false, value: 'documentocontable.descripcion', width:'auto', class: ['no-gutters black--text']  },
                 { text: 'CONCEPTO', sortable: false, value: 'concepto', width:'auto', class: ['no-gutters black--text']  },
                 { text: 'ESTADO', sortable: false, value: 'activa', width:'auto', class: ['no-gutters black--text'] },
                 ]"
              dense
              :items="listDatos"  
              :search="search"
              @click:row="datostabla"
              @pagination="cargarPaginacion"
              :items-per-page="paginator.itemsPerPage"
              :server-items-length="TotalRegistros"
            >


<template v-slot:item.valor="props">
    <span>{{currencyFormatter(props.item.valor )}}</span>
</template>


<template v-slot:item.nuevaFecha="props">
                <span style="font-size:12px; display:none;">{{props.item.indx = listDatos.indexOf(props.item)}}</span>
                <span style="font-size:12px;" >{{ FormatoFecha(props.item.nuevaFecha) }}</span>
 </template>

<template v-slot:item.nombre="props">
    <span v-if="props.item.facturasventa.hasOwnProperty('nombreDgii') && props.item.facturasventa.nombreDgii!=null"> {{props.item.facturasventa.nombreDgii.trim() }}</span>
</template>

<template v-slot:item.activa="props">
  <span style="font-size: 13px"> 
    <b v-if="props.item.activa==true" class="green--text">ACTIVO</b>
    <b v-if="props.item.activa==false" class="red--text">ANULADO</b>
  </span>
 </template>

<!-- <template v-slot:body.append v-if="windowSize.width >600">
<tr>  
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong class="d-flex justify-end" style="font-size:15px; color: #00838F;">Total:</strong></td>                                                                               
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(0)}} </strong></td>
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(0)}} </strong></td>
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(0)}} </strong></td>
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(0)}} </strong></td>
<td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(0)}} </strong></td>
 
 </tr>
 </template>

 <template v-slot:footer v-if="windowSize.width<=600">
<v-list-item style="font-size: 70%;" class="white--text" > 
      <v-list-item-content>
        <span>Total Meta de Ventas:0.00</span>
        <span>Total Ventas:0.00</span>
        <span>Total % Comisión:0.00</span>
       <span>Valor Comisiones:0.00</span>
      </v-list-item-content>
</v-list-item>

  </template> -->
</v-data-table>
 </div>
</v-col>
      
    </div>
  </v-card>

 </div>
<hr />
<v-col v-if="UtilGastosMenores!=null" cols="12" md="12" sm="12" class="pa-0 ma-0 px-2 pt-1">
  <div class="px-2 pt-1" style="border: 1px solid #000000">
              <!-- cuerpo GASTOS -->
               <v-row>
                    <v-col class=" py-0 my-0" cols="12" md="8" sm="8">
                      <v-row>

                        <v-col cols="12" md="3" sm="3">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-text-field id="ImputColorDisable"
                              v-on="on" dense outlined  type="date" label="Fecha"
                              v-model="UtilGastosMenores.fecha" placeholder=" "  
                              style="font-size: 12px"  hide-details disabled>
                              <template v-slot:prepend>
                                <i style="font-size: 16px" class="fa fa-calendar"></i>
                              </template>
                            </v-text-field>
                          </template>
                          <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                            <span>Se muestra la fecha del gasto.</span>
                          </i>
                        </v-tooltip>
                       </v-col>

                        <v-col cols="12" md="6" sm="6">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-combobox id="ImputColorDisable"
                                v-on="on" v-model="UtilGastosMenores.documentocontable" autocomplete="off"
                                dense outlined label="Documentos:" item-text="descripcion" :rules="[$rules.required]"
                                disabled  style="font-size: 13px"  hide-details  >
                                <template v-slot:prepend>
                                  <i style="font-size: 18px" class="fa fa-book"></i>
                                </template>
                              </v-combobox>
                            </template>
                            <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                              <span>Se muestra el documento de la Devolucion de venta.</span>
                            </i>
                          </v-tooltip>
                        </v-col>

                        <v-col cols="12" md="3" sm="3">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-on="on"  id="ImputColorDisable"
                                label="No.Gasto:"  dense
                                autocomplete="off"  outlined
                                :value="`${UtilGastosMenores.documentocontable.nombrecorto.trim()}-${UtilGastosMenores.gastosmenoresPK.secuencia}`"
                                style="font-size: 13px"
                                disabled hide-details>
                                <template v-slot:prepend>
                                  <i style="font-size: 18px" class="fa fa-hashtag"></i>
                                </template>
                              </v-text-field>
                            </template>
                            <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                              <span>Se muestra el número de la devolucion.</span>
                            </i>
                          </v-tooltip>
                        </v-col>

                          <v-col cols="12" md="9" sm="9">
                          <v-combobox id="formdisabledInput" disabled autocomplete="off" dense outlined label="Monedas"  item-text="descripcion"
                             v-model="UtilGastosMenores.moneda" style="font-size:13px;" >

                              <template v-slot:prepend>
                              <i style="font-size: 20px;" class="fa fa-money"></i>
                              </template>

                              <template v-slot:selection="{ attrs, item, parent, selected }">
                              <span id="ImputColorDisable">
                              {{ item.descripcion }} ({{ item.nombrecorto }})
                              </span>
                              </template>

                              <template slot="item" slot-scope="item">
                              <!--<v-col cols="12" md="12" sm="12"> <v-row no-gutters></v-row> </v-col>-->
                              <v-col style="font-size: 13px;" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                                <p class="pa-0 ma-0 py-0 my-0"><b>{{ item.item.descripcion }} ({{ item.item.nombrecorto }})</b></p>
                              </v-col>
                              </template>
                          </v-combobox>
                          </v-col>

                          <v-col cols="12" md="3" sm="3">
                            <VueAutonumeric v-if="UtilGastosMenores.moneda != null" id="formdisabledInput" label="Tasa:" dense outlined
                            v-model.number="UtilGastosMenores.tasa" disabled>
                            <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-usd"></i>
                            </template>
                            </VueAutonumeric>
                          </v-col>

                      </v-row>
                    </v-col>
                    <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="4" sm="4">
                      <v-col cols="12" md="12" sm="12">
                          <v-textarea  id="formdisabledInput" disabled autocomplete="off" label="Concepto:" rows="4" dense outlined auto-grow
                          v-model="UtilGastosMenores.concepto">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-commenting"></i>
                          </template>
                        </v-textarea>
                      </v-col>
                        
                    </v-col>
                </v-row>
                  <!-- FIN cuerpo GASTOS -->

    </div>

  <v-card color="grey lighten-3" > 
    <v-col style="background-color:#BDBDBD; border: 1px solid #000000; " class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
      <span :class="`pl-2 d-flex justify-start black--text`"><b>GASTOS</b></span>
    </v-col>
      <div class="px-2 pt-1" style="border: 1px solid #000000">
        <v-form v-model="valid" ref="formTabGasto" lazy-validation> 
          <v-data-table class="elevation-1" dense
                          :headers="[{ text: 'Fecha', value: 'nuevaFecha', class: ['no-gutters black--text'] ,width:'auto',sortable:false, class: ['no-gutters black--text'] }, { text: 'Categoría de gastos', value: 'categoria',width:'auto',sortable:false, class: ['no-gutters black--text'] },
                          { text: 'CONCEPTO', value: 'concepto',width:'auto',sortable:false, class: ['no-gutters black--text'] },{ text: 'VALOR', value: 'valor',width:'auto',  align: 'center',sortable:false, class: ['no-gutters black--text'] },
                          ]"
                          :items="UtilGastosMenores.gastosmenoresDetalleList" :items-per-page="-1">

                          <!-- <template v-slot:item.action="{ item }">
                            --<v-btn fab @click.prevent="editFact(item)" x-small color="grey "><i style="font-size: 20px;" class="fa fa-pencil"></i></v-btn>--  
                            <v-btn fab @click.prevent="delGasto(item)" x-small color="red darken-3">
                              <i style="font-size: 20px;" class="fa fa-trash-o"></i></v-btn>
                          </template>-->


                          <template v-slot:item.nuevaFecha="props">
                            <v-text-field disabled id="ImputColorDisable" dense outlined type="date" label="* Fecha:" v-model="props.item.nuevaFecha" hide-details>
                            </v-text-field>
                          </template>


                          <template v-slot:item.concepto="props">
                            <v-textarea disabled id="ImputColorDisable" auto-grow autocomplete="off" label="" rows="1" dense outlined v-model="props.item.concepto"
                              hide-details>
                            </v-textarea>
                          </template>

                          <template v-slot:item.categoria="props">
                            <v-combobox disabled id="ImputColorDisable" v-model="props.item.categoria" label="" required outlined dense
                               autocomplete="off"  item-text="descripcion"  hide-details>
                            </v-combobox>
                          </template>


                          <template v-slot:item.valor="props">
                            <VueAutonumeric disabled id="ImputColorDisable"  autocomplete="off" label="" dense outlined v-model="props.item.valor"  hide-details>
                            </VueAutonumeric>
                          </template>

                          <template v-slot:body.append v-if="windowSize.width >600">
            <tr>
              <td class="border-top-bottom"><strong></strong></td>
              <td class="border-top-bottom"><strong></strong></td>
              <!-- <td class="border-top-bottom"  ><strong></strong></td> -->
              <td class="border-top-bottom"><strong class="d-flex justify-end"
                  style="font-size:15px; color: #00838F;">Total:</strong></td>
              <!-- <td class="border-top-bottom"  ><strong></strong></td> -->
              <td class="border-total"><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;">
                  {{ currencyFormatter(sumTotalGasto(UtilGastosMenores.gastosmenoresDetalleList)) }} </strong></td>
              <!-- <td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(form.TotalProd.importe)}} </strong></td> -->
              <!-- <td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(form.Total.Total)}} </strong></td> -->
              <!-- <td class="border-top-bottom"  ><strong></strong></td> -->
            </tr>
      </template>

      <template v-slot:footer v-if="windowSize.width<=600">
        <v-list-item style="font-size: 70%;" class="white--text">
          <v-list-item-content>
            <span>TOTAL: {{ currencyFormatter(sumTotalGasto(UtilGastosMenores.gastosmenoresDetalleList)) }}</span>
          </v-list-item-content>
        </v-list-item>

      </template>
        </v-data-table>
        </v-form>

        <v-data-table class="elevation-1" dense :headers="[{ text: 'NCF', value: 'ncf', class: ['no-gutters black--text'] ,width:'auto',sortable:false, class: ['no-gutters black--text'] }, { text: 'CATEGORÍA DE GASTOS', value: 'categoriagastos.descripcion',width:'auto',sortable:false, class: ['no-gutters black--text'] },
{ text: 'VALOR', value: 'valor',width:'auto',  align: 'center',sortable:false, class: ['no-gutters black--text'] },
{ text: 'ESTADO', sortable: false, value: 'estado', width: 150, class: ['no-gutters black--text'] },
{ text: 'ACCIÓN', value: 'action', width: '130', sortable: true, class: ['no-gutters black--text'] }
]"
  :items="UtilGastosMenores.gastoMenoresNcfList" :items-per-page="-1">
                     <template v-slot:item.estado="props">
                      <span style="display:none;">{{ props.item.indx = UtilGastosMenores.gastoMenoresNcfList.indexOf(props.item) }}</span>
                          <span style="font-size: 13px"> <b :class="claseColorEstado(props.item.trackId)">{{ getEstado(props.item.trackId) }}</b>
                            
                          </span>
                        </template>

                    <template v-slot:item.action="{ item }">

                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                    <v-btn :disabled="verificarGastosEmitir(item)"  v-on="on" fab @click.prevent="emitirGastoEletronico(item)" x-small color="blue">
                      <i style="font-size: 20px;" class="fa fa-refresh"></i>
                    </v-btn>
                    </template>
                    <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                          <span> Enviar Comprobante eletronico.</span>
                        </i>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                    <v-btn :disabled="verificarGastosEliminar(item)"  v-on="on" fab @click.prevent="notifEliminarGastos(item)" x-small color="red"><i
                        style="font-size: 20px;" class="fa fa-trash"></i>
                    </v-btn>

                    </template>
                    <i style="font-size: 20px" dark dense class="fa fa-info-circle">
                       <span> Eliminar Registro.</span>
                     </i>
                     </v-tooltip>


                </template>


</v-data-table>

      </div>
  </v-card>
</v-col>
        </v-app> 
      </td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir" >

 <div  class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
        
<!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
</div>

      </td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



    </tr>
  </table>
<!-- Modales -------------------------------------------------------------------------------------------------->
  <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                @keyup="filtro"
                label="Buscar"
                single-line
                hide-details
              >
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
      label="myAlert"
      v-model="Elim_notif.estado"
      persistent
      max-width="350"
      transition="fab-transition"
    >
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            @click.prevent="
              eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            "
            small
          >
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

<!-- ------------------------------------------------------ Modal- Notificacion Confirmacion Adicional -->
    <v-dialog transition="fab-transition" label="Modal Notificaciones" v-model="notifConfAdicional.estado" persistent
      max-width="60%" max-height="85%">

      <!--------------------- Creacion de Otros Ingresos ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

     
        <v-col style="background-color:#dd4b39;" class="pa-2 ma-0 py-1 my-0" cols="12" md="12" sm="12">
            <span style="font-size: 22px;"  :class="`d-flex justify-start white--text`"> <i dense class="fa fa-info-circle"> <b> NOTIFICACIÓN</b></i></span>
         </v-col>
        
        <v-card >
          <!-- style="border: 1px solid #000000;" -->
          <!-- columna informacion  -->
          <v-col style="border: 1px solid #000000;"   class="pa-0 ma-0 py-2 my-0" cols="12" md="12" sm="12" :class="`d-flex justify-center`">
            <center >
            <!-- <h2 class="py-5">  </h2> -->
              <code :class="`black--text`" style=" font-size: 25px;border: 1px solid #000000;">
              <b>{{ notifConfAdicional.nombre }}</b>
              </code>


           <v-card-actions :class="`d-flex justify-center`">


            <v-btn  color="green" v-if="notifConfAdicional.Exec == 'contEmitirGastoEletronico'"
            @click.prevent="emitirGastoEletronico(notifConfAdicional.objTemp)" large>
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
            </v-btn>

          <v-btn  color="green" v-if="notifConfAdicional.Exec == 'contEliminarGastos'"
            @click.prevent="eliminarGastos(notifConfAdicional.objTemp)" large>
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn  color="red" 
          @click.prevent="cerrarNotificacion" large>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>

           </v-card-actions>

          
            </center>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
     <!-- ------------------------------------------------------ FIN Modal- Notificacion Confirmacion Adicional  -->


<!-- fn Modales ----------------------------------------------------------------------------------------------->
<!---------------------  Panel Menu Opcion Botones style="max-height:300px;" ------------------------------->
<div class="overflow-x-auto" v-show="false">
              <!-- columna  ---------------------->
              <PvDgiiFacturacionEletronica ref="RefPvDgiiFacturacionEletronica" />
</div>
<!---------------------  Panel Menu Opcion Botones style="max-height:300px;" ------------------------------->
<div class="overflow-x-auto" v-show="false">
              <!-- columna  ---------------------->
              <ComponentsPvImprecionViewer ref="RefPvImprecionViewer" />
</div>


  </div>
</template>

<script>
import { EventBus } from "../event-bus";
import BarraBusqueda2 from "../components/BarraBusquedaDinam";
import VueAutonumeric from "../components/AutoNumericNuevo"
import ContenidoBase from "../components/ContenidoBase";
import {currencyFormatter,FormatoFecha,HoraFormatter,fechaNueva} from "@/js/Funciones.js";
import PvDgiiFacturacionEletronica from "@/PuntodeVenta/UtilidadComponents/PvDgiiFacturacionEletronica.vue";
import ComponentsPvImprecionViewer from "@/PuntodeVenta/UtilidadComponents/PvImprecionViewer.vue";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    VueAutonumeric,
    PvDgiiFacturacionEletronica,
    ComponentsPvImprecionViewer
  },

  created() {
    var json = {
      titulo: "Inventario Físico",
      descripcion: "Inventario Físico",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi:false,
      
      accion: [
        "UtilGastosMenoresNew",
        "UtilGastosMenoresSave",
        "UtilGastosMenoresRemove",
        "UtilGastosMenoresAnular",
        "UtilGastosMenoresPrintList"
      ], 
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("UtilGastosMenoresNew", this.new);
    // EventBus.$on("UtilGastosMenoresSave", this.save);
    // EventBus.$on("UtilGastosMenoresRemove", this.remove);
    // EventBus.$on("UtilGastosMenoresAnular", this.remove);
    // EventBus.$on("UtilGastosMenoresPrintList", this.imprimirList);
    EventBus.$on("emitUtilGastosMenores", this.datostabla);
    EventBus.$on("onResize", this.onResize);
  },

  data:()=>  ({


      selected:[],
      listDatos:[],
      windowSize:{width:"auto", height:"auto"},
      TotalRegistros: 1,
      resertPagi: true,
      paginator: {
        itemsPerPage: 15,
        pageStart: 1,
        page: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },

      busquedaGastosMenores: {
        fechaInicial: fechaNueva(),
        fechaFinal:fechaNueva(),
        opcion:0,
        Nogasto:0,
        ncf:'',
        buscarTrackId:''
        //fechaCreacion: new,
      //  fechaModificacion: "", 
      },

      UtilGastosMenores:null,

      notifConfAdicional: {
      estado: false,
      nombre: "",
      Exec: "",
      objTemp:null
    },

totales:{
  costo:0,
  cantidad:0,
  valor:0
},



EstadoBtn:{ 
        BarraTablaDinamicaAprir:false,
        nuevo:true,
        guardar:false,
        eliminar:false,
        anular:false,
        imprimir:false,
        vercuenta:false,
        guardartemporal:false,
        restaurartemporal:false,
        importarDato:false,
        cargarProducto:false,
        ImprimirproductoInv:false,
        },

      text: "",
      valid: true,
     BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:"
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" }
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?"
      },

      aalert: {
        estado: false,
        color: null
      },
    
    }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
currencyFormatter,FormatoFecha,HoraFormatter,fechaNueva,
onResize(e){
// this.windowSize=e
},

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

    },
    
    save() { },
    remove() { },
    eliminar() { },
    anular() { },
    imprimirList() {},
    newwnuevo() {
     this.UtilGastosMenores = null,

     this.selected=[]
     this.listDatos=[]
     this.TotalRegistros= 1
     this.resertPagi= true
      this.paginator= {
        itemsPerPage: 15,
        pageStart: 1,
        page: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5,
      },

      this.busquedaGastosMenores= {
        fechaInicial: fechaNueva(),
        fechaFinal:fechaNueva(),
        opcion:0,
        Nogasto:0,
        ncf:'',
        buscarTrackId:''
      },

      this.UtilGastosMenores=null,

        EventBus.$emit("actualizaBarraBusqueda2");
    },


BlurDesde(){
if(this.busquedaGastosMenores.fechaInicial.toString().length==0){
  this.busquedaGastosMenores.fechaInicial=new Date().toISOString().substr(0,10)
}

 },


 BlurHasta(){

if(this.busquedaGastosMenores.fechaFinal.toString().length==0){
  this.busquedaGastosMenores.fechaFinal=new Date().toISOString().substr(0,10)
}

 },



 getGastosMenores() {
        // if(this.busquedaGastosMenores.NoFactura.length==0){this.busquedaGastosMenores.NoFactura=0}

        if(this.$store.getters.GetdatosInfUsu==null){
        return
        }
        if (
          (this.busquedaGastosMenores.Nogasto != null && this.busquedaGastosMenores.Nogasto.length == 0) ||
          this.busquedaGastosMenores.Nogasto == 0
        ) {
          this.busquedaGastosMenores.Nogasto = null
        }
        if (this.busquedaGastosMenores.ncf != null && this.busquedaGastosMenores.ncf.length == 0) {
          this.busquedaGastosMenores.ncf = null
        }

        if (this.$refs.formGastoMenores.validate()) {
  
          var objDat = JSON.parse(JSON.stringify(this.busquedaGastosMenores))
          if (this.busquedaGastosMenores.documento != null) {
            objDat.documento = this.busquedaGastosMenores.documento.codigo
          }else{
            objDat.documento=null
          }

          objDat.limit = this.paginator.itemsPerPage
          objDat.ultimo = this.paginator.pageStart


var obj = this.paginator.itemsPerPage + "/" + this.paginator.pageStart + "/" + this.busquedaGastosMenores.Nogasto + "/" + objDat.documento + "/" + this.busquedaGastosMenores.fechaInicial + "/" + this.busquedaGastosMenores.fechaFinal
      this.$axios.get(this.$hostname + this.$hName + '/gastosmenores/findListGastMenoresPlus/' + obj, { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.listDatos = res.data.ListItems, this.TotalRegistros = res.data.TbTotalItem
        })
 .catch((error) => {
              this.alerta("Reporte no Impreso(" + error + ")", "error")
            })
          // this.$axios
          //   .post(this.$hostname + this.$hName + "/utilitarioDevolucion/consultaDevolucion", obj, {
          //     headers: this.$store.getters.GetheadersAxios,
          //   })
          //   .then((res) => {
          //     // this.GetDataFact(res.data)
          //     ;(this.TotalRegistros = res.data.TbTotalItem), (this.listDatos = res.data.ListItems)
          //   })
           
        } else {
          this.alerta("Los campos en rojo son requeridos", "error")
        }
      },

 obtenerDatoSelect(e) {
        this.datostabla(e.item)
      },


      datostabla(e) {
        var eftc = JSON.parse(JSON.stringify(e))

        if(eftc.gastosmenoresDetalleList.length>0){
          eftc.gastosmenoresDetalleList= eftc.gastosmenoresDetalleList.filter((ee) => ee.borrado==false)
        }
        
        if(eftc.gastoMenoresNcfList.length>0){
            eftc.gastoMenoresNcfList= eftc.gastoMenoresNcfList.filter((ee) => ee.borrado==false)
          }

        eftc.fecha= eftc.nuevaFecha
        this.selected = []
        this.selected.push(JSON.parse(JSON.stringify(e)))
        this.UtilGastosMenores = eftc

      },


 KeyUpCantidad(e) {
        //  if(e.key.charCodeAt(0)>=48 & e.key.charCodeAt(0)<=57 ){}

        if (e.target.value.length == 0) {
          e.target.value = 0
        }

        if (e.key) {
          var mynumeral = require("numeral")
          e.target.value = mynumeral(e.target.value).value()

          //console.log(mynumeral(""+this.mensajero.metadeenvios)).value()
          if (e.target.value == null) {
            e.target.value = 0
          }
        } else {
          e.key = ""

          //console.log("no se puede poner letras o signos")
        }

        if (e.target.value.length == 0) {
          e.target.value = 0
          e.key = 0
        }
      },


    resertPaginacion() {
            this.resertPagi = false

            this.paginator.page = 1
            this.paginator.pageStart = 0
            this.paginator.pageStop = this.paginator.itemsPerPage

            var _this = this
            setTimeout(function () {
              _this.resertPagi = true
            }, 500)

            //setTimeout(this.resertPagi=true,1500);
          },

    cargarPaginacion(e) {
            this.selected = []
            // console.log('cargarPaginacion')
            //     console.log(e);
            this.paginator = e

            if (this.paginator.itemsPerPage == -1) {
              this.paginator.itemsPerPage = 15
              // this.paginator.itemsPerPage.push(15)
            }

            this.getGastosMenores()
            //   this.filtro();
          },


    sumTotalGasto(LISTA){

      var sumaValor = LISTA.reduce((total, item) => total + item.valor, 0);
      return sumaValor;

    },
    getEstado(e){
          var ESTADO="N/A"
          if(e!=null && e.includes('estado')&&  typeof JSON.parse(e) ==="object"){
          ESTADO=JSON.parse(e).estado
          }
          return ESTADO
        },


     claseColorEstado(e){
      var COLOR=" blue--text "
      //Aceptado: green--text  ,Rechazado: red--text ,Reenviado: orange--text ,N/A: blue--text 
      if(e!=null && e.includes('estado')&& typeof JSON.parse(e) ==="object"){
        var ESTADO=JSON.parse(e).estado
        if(ESTADO.includes('Aceptado')){ COLOR=" green--text "}
        if(ESTADO.includes('Rechazado')){ COLOR=" red--text "}
        // if(ESTADO.includes('Reenviado')){ COLOR=" orange--text "}
      }else{
        COLOR=" blue--text "
      }
      return COLOR
    },

notifEliminarGastos(notifConfAdicional){
this.notifConfAdicional= {
      estado: true,
      nombre: `\n¿Desea eliminar este registro \nNCF:${ notifConfAdicional.ncf!=null? notifConfAdicional.ncf.trim():''} MONTO: ${ this.currencyFormatter(notifConfAdicional.valor)} ?`,
      Exec: "contEliminarGastos",
      objTemp: notifConfAdicional,
    }
    return
      },


cerrarNotificacion(){
this.notifConfAdicional= {
      estado: false,
      nombre: "",
      Exec: "",
      objTemp:null
    }
},


emitirGastoEletronico(item){
 
  EventBus.$emit("loading", true);

  if(item.ncfVencimientonuevaFecha!=null && item.ncfVencimientonuevaFecha.trim().length>0){
    item.ncfVencimiento=item.ncfVencimientonuevaFecha
  }
  
//_this.findGastoFacEletronico(res.data.gastosmenoresPK.secuencia,res.data.gastosmenoresPK.documento)
var codigo = this.UtilGastosMenores.gastosmenoresPK.secuencia
var documento = this.UtilGastosMenores.gastosmenoresPK.documento

 this.$axios.get(
            this.$hostname + this.$hName + "/gastosmenores/find/" + codigo+"/"+documento,
            { headers: this.$store.getters.GetheadersAxios }
          )
.then((res) => { 
  // this.datostabla(res.data)
 if( res.data.documentocontable.hasOwnProperty('datoSucursal')&& res.data.documentocontable.datoSucursal!=null && res.data.documentocontable.datoSucursal.facturacionEletronica==true){
this.facturacionEletronicaGet(res.data,item)
}else{
 this.alerta("Dato guardado correctamente!", "bien")
                    //  _this.enviarImprimirFactura(res.data)
                    }
})
.catch((error) => { console.error(error); });
},

 async facturacionEletronicaGet(RESDATA,ITEM){
var OBJ=JSON.parse(JSON.stringify(ITEM))
var INFGASTO={
    sucursal:RESDATA.documentocontable.datoSucursal,
    tipocomprobante:RESDATA.documentocontable.datoSucursal.secuenciaComprobante.tipocomprobante,
    //ncfVencimientonuevaFecha:RESDATA.documentocontable.datoSucursal.secuenciaComprobante.nuevaFechaVencimiento,
    ncfVencimientonuevaFecha:RESDATA.ncfVencimientonuevaFecha,
    ncf:ITEM.ncf,
    valor:ITEM.valor,
    ListDet:[]
  }
  OBJ.descripcion= OBJ.categoriagastos.descripcion.trim()
var ObjProRow = RESDATA.gastosmenoresDetalleList.filter((ee) => ee.categoria.codigo == OBJ.gastoMenoresNcfPK.categoria && ee.valor == OBJ.valor );
    if(ObjProRow.length>0){
      // OBJ.descripcion= ObjProRow[0].categoria.descripcion.trim()
      INFGASTO.nuevaFecha=ObjProRow[0].nuevaFecha
  }else{
      INFGASTO.nuevaFecha=RESDATA.nuevaFecha
  }
  INFGASTO.ListDet.push(OBJ)
  
  var resObjCompleto  =  await this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_ECF_GASTOSMENORES(INFGASTO);
 var GASTO_DATA=OBJ.gastoMenoresNcfPK
      GASTO_DATA.ncf= OBJ.ncf

  if(resObjCompleto.objtrackId.estado==="Rechazado"){

  var Lis_msj_Error=""
  Promise.all(resObjCompleto.objtrackId.mensajes.map(async (element) => { 
   // Lis_msj_Error+=` *- COD:${element.codigo} :${element.valor} \n`
   msj_Error+=` *- COD:${element.codigo} :${element.valor} \n`
  }));

  this.actualizarFAC_ELETRONICA(GASTO_DATA,resObjCompleto)

return
}
this.actualizarFAC_ELETRONICA(GASTO_DATA,resObjCompleto)
 },

 actualizarFAC_ELETRONICA(GASTO,objCompTrackId){
 var TRACK =objCompTrackId.objtrackId
  //delete TRACK["mensajes"]

  var objTrack={
    secuencia:GASTO.secuencia,
    documento:GASTO.documento,
    categoria:GASTO.categoria,
    ncf:GASTO.ncf,
    fechafirmadgii:objCompTrackId.fechafirmadgii,
    qrdgii:objCompTrackId.qrdgii,
    signatureValue:objCompTrackId.signatureValue,
    trackId:JSON.stringify(TRACK)
  }
  
  this.$axios.post(this.$hostname + this.$hName + "/gastosmenores/actualizarGastoMenoreEletronica",
  objTrack,{ headers: this.$store.getters.GetheadersAxios })
            .then((res) => {
              var gastosmenoresPK=this.UtilGastosMenores.gastosmenoresPK
              EventBus.$emit("loading", false);
              this.selected=[]
              this.getGastosMenores()
              if(objCompTrackId.objtrackId.estado==="Aceptado"){
              //this.enviarImprimirFactura(res.data)
             // this.alerta("Dato guardado correctamente!", "bien")
             console.log("Dato guardado correctamente!")
              }

               if(objCompTrackId.objtrackId.estado==="Aceptado Condicional"){
              //this.enviarImprimirFactura(res.data)
              //this.alerta("Dato guardado correctamente!", "bien")
              console.log("Dato guardado correctamente!")
              }
              this.findGastosMenor(gastosmenoresPK)
            })
            .catch((error) => {
              EventBus.$emit("loading", false);
              console.log("actualizartoken no guardado correctamente-->",error)
            });
},


findGastosMenor(gastosmenoresPK){

var codigo = gastosmenoresPK.secuencia
var documento = gastosmenoresPK.documento

 this.$axios.get(
            this.$hostname + this.$hName + "/gastosmenores/find/" + codigo+"/"+documento,
            { headers: this.$store.getters.GetheadersAxios }
          )
.then((res) => { 
   this.datostabla(res.data)
})
.catch((error) => { console.error(error); });


},


 
eliminarGastos(ITEM){
  
  var codCat= ITEM.categoriagastos.codigo
  var GASTO_ME_LIST_FILTRADO = this.UtilGastosMenores.gastosmenoresDetalleList.filter((ee) => ee.categoria.codigo!=codCat)
  var GASTO_ME_LIST_ELIMINAR = this.UtilGastosMenores.gastosmenoresDetalleList.filter((ee) => ee.categoria.codigo===codCat)
  
var OBJ={
  gastosmenoresPK:this.UtilGastosMenores.gastosmenoresPK,
  gastosmenoresDetalle:GASTO_ME_LIST_ELIMINAR,
  gastoMenoresNcf:ITEM
}
EventBus.$emit("loading", true);

this.$axios.post(this.$hostname + this.$hName + "/gastosmenores/utilitarioBorrarGastoMenoreEletronica", OBJ,
              { headers: this.$store.getters.GetheadersAxios })
            .then(res => {
               this.selected=[]
                /*this.UtilGastosMenores.gastosmenoresDetalleList=JSON.parse(JSON.stringify(GASTO_ME_LIST_FILTRADO))
                const index = this.UtilGastosMenores.gastoMenoresNcfList.indexOf(ITEM)
                this.UtilGastosMenores.gastoMenoresNcfList.splice(index, 1)*/

              this.getGastosMenores()
              EventBus.$emit("loading", false);
              this.cerrarNotificacion()
             this.alerta("DATO MODIFICADO (REVISE) ", "bien")
              console.log('Verificando-->',res.data)
              this.datostabla(res.data)

            })
            .catch(error =>{
              EventBus.$emit("loading", false);
              this.alerta("Dato no MODIFICADO", "error")
            });




},


verificarGastosEliminar(item){
var ESTADO=this.getEstado(item.trackId);
var BOOL =  !(ESTADO.includes("Rechazado") || ESTADO.includes("N/A"))
return BOOL
},

verificarGastosEmitir(item){
var BOOL =  !this.getEstado(item.trackId).includes("N/A")
return BOOL
},


alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },


    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {},




  },

computed:{

    ActDescBtn(){
        this.windowSize=JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize)) 

    }
  }

};
</script>

<style></style>
